import { RECEIPT_STATUS_LABELS, type ReceiptStatus } from '@chukua/common';
import { Tag } from 'antd';

const COLORS: Record<ReceiptStatus, string> = { pending: 'warning', cleared: 'success', bounced: 'error', reversed: 'default' };

export function ReceiptStatusTag({ status }: { status: ReceiptStatus }) {
  return <Tag color={COLORS[status]}>{RECEIPT_STATUS_LABELS[status]}</Tag>;
}
